module.exports = __webpack_public_path__ + "static/img/101856.05a3846e.png";